<template>
    <div :class="['item', 'item-large', 'item--'+item.type]">
        <div class="header">
            <div class="left">
                <div
                    class="avatar"
                    :style="item.initiatorAvatar ? { backgroundImage: `url(${item.initiatorAvatar})`} : {}"
                ></div>
                <div class="title">
                    <div class="pair-name">
                        {{ pairFullName }}
                    </div>
                    предлагает встречу
                </div>
            </div>
            <div>
                <div class="date">
                    <span class="time">{{ item.datetime | timestampTime(true) }}</span>
                    {{ item.datetime | timestampFullDate(false, true) }}
                </div>
            </div>
        </div>
        <div class="content">
            <div class="theme">
                {{ item.theme }}
            </div>
            <div class="description">
                {{ item.description }}
            </div>
            <div class="location">
                {{ item.location }}
            </div>
        </div>
        <div class="actions">
            <div
                class="action_btn"
                @click="accept"
            >
                Принять
            </div>
            <div
                class="action_btn"
                @click="changeDate"
            >
                Изменить дату
            </div>
            <div
                class="action_btn action_btn--cancel"
                @click="decline"
            >
                Отклонить
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {ActivityStatus} from '../../../../../stores/mentoring/activities';

const actions = [
    'updateActivityStatus',
];

export default {
    name: 'MeetingMentorCard',
    data: () => ({
    }),
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    methods: {
        ...mapActions('mentoring/activities', actions),
        accept() {
            this.updateActivityStatus({item: this.item, status: ActivityStatus.in_progress});
        },
        changeDate() {
            this.$emit('click', 'change_date');
        },
        decline() {
            this.$emit('click', 'decline');
        },
    },
    computed: {
        ...mapState('mentoring', [
            'pair',
            'role',
        ]),
        pairFullName() {
            if (!this.pair) return '';
            return `${this.pair.surname} ${this.pair.name}`;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../../../styles/rem';
    .item-large {
        padding: rem(16);

        @include on-mobile {
            padding: mrem(16);
        }
    }
    .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: rem(16);


        @include on-mobile {
            margin-bottom: mrem(16);
            flex-wrap: wrap;

            .date {
                width: 100%;
            }
        }

        .left {
            display: flex;
            flex-direction: row;

            @include on-mobile {
                width: 100%;
                flex-direction: row-reverse;
                justify-content: space-between;
                margin-bottom: mrem(8);
            }

            .title {
                font-size: rem(14);
                line-height: rem(20);
                color: #8F9398;
                margin-left: rem(16);

                @include on-mobile {
                    font-size: mrem(14);
                    line-height: mrem(20);
                    margin-left: 0;
                }
            }
        }
    }
    .pair-name {
        font-weight: 600;
        font-size: rem(14);
        line-height: rem(20);
        color: #3AA0FD;
        margin-bottom: rem(4);

        @include on-mobile {
            font-size: mrem(14);
            line-height: mrem(20);
            margin-bottom: mrem(4);
        }
    }

    .theme {
        font-weight: 600;
        font-size: rem(16);
        line-height: rem(24);
        color: #000000;
        margin-bottom: rem(8);

        @include on-mobile {
            font-size: mrem(16);
            line-height: mrem(24);
            margin-bottom: mrem(8);
        }
    }
    .description,
    .location {
        font-size: rem(16);
        line-height: rem(24);
        color: #000000;
        margin-bottom: rem(8);

        @include on-mobile {
            font-size: mrem(16);
            line-height: mrem(24);
            margin-bottom: mrem(8);
        }
    }

    .actions {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;

        .action_btn {
            width: rem(209);

            @include on-mobile {
                width: 100%;
            }

            &--cancel {
                border: 1px solid #EF627D!important;
                color: #EF627D!important;
            }
        }
    }
</style>